import _Vue from "vue";
import Crypto from "crypto";
import app from "@/main";
import {Evrak} from "./store/modules/TaskDataInterface/EvrakGonderTaskDataInterface";
import {ITask} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import JSZip from "jszip";
import FileSaver from "file-saver";
import {TakipTalebiIndirCevap} from "@/plugins/uyap-plugin/uyap/TakipTalebiIndir";

export class UyapHelper {
    normalizeBase64(b64Data: string): string {
        if (!b64Data || typeof b64Data !== 'string') return '';
        let s = b64Data.trim();
        const base64Part = s.split(';base64,');
        if (base64Part.length > 1) s = base64Part[1];
        s = s.replace(/<!--\[CDATA\[/g, '').replace(/\]\]-->/g, '');
        s = s.replace(/\s/g, '');
        s = s.replace(/-/g, '+').replace(/_/g, '/');
        const pad = s.length % 4;
        if (pad) s += '='.repeat(4 - pad);
        return s;
    }

    base64toBlob(base64Data: any, contentType: any): Blob {
        contentType = contentType || '';
        const sliceSize = 1024;
        const normalized = this.normalizeBase64(base64Data);
        const byteCharacters = window.atob(normalized);
        const bytesLength = byteCharacters.length;
        const slicesCount = Math.ceil(bytesLength / sliceSize);
        const byteArrays = new Array(slicesCount);

        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            const begin = sliceIndex * sliceSize;
            const end = Math.min(begin + sliceSize, bytesLength);

            const bytes = new Array(end - begin);
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, {type: contentType});
    }

    base64DataCleaner(data: Evrak): Evrak {
        let splitedB64: any = (data.base64 as string).split(";base64,");
        if (splitedB64.length > 1) {
            data.base64 = splitedB64[1];
            data.type = splitedB64[0].split("data:")[1]
        }
        return data;
    }

    formatDate(tarih: any){
        let day = tarih.date.day < 10 ? ("0" + tarih.date.day) : tarih.date.day;
        let month = tarih.date.month < 10 ? ("0" + tarih.date.month) : tarih.date.month;
        let year = tarih.date.year;
        let hour = tarih.time.hour < 10 ? ("0" + tarih.time.hour) : tarih.time.hour;
        let minute = tarih.time.minute < 10 ? ("0" + tarih.time.minute) : tarih.time.minute;
        let second = tarih.time.second < 10 ? ("0" + tarih.time.second) : tarih.time.second;
        return year + "-" + month + "-" + day + "T" + hour + ":" + minute + ":" + second;
    }

    tarihLocaleStr(dosyaAcilisTarihi: any) {
        if(!dosyaAcilisTarihi)
            return "";
        let day = dosyaAcilisTarihi.date.day < 10 ? ("0" + dosyaAcilisTarihi.date.day) : dosyaAcilisTarihi.date.day;
        let month = dosyaAcilisTarihi.date.month < 10 ? ("0" + dosyaAcilisTarihi.date.month) : dosyaAcilisTarihi.date.month;
        let hour = dosyaAcilisTarihi.time.hour < 10 ? ("0" + dosyaAcilisTarihi.time.hour) : dosyaAcilisTarihi.time.hour;
        let minute = dosyaAcilisTarihi.time.minute < 10 ? ("0" + dosyaAcilisTarihi.time.minute) : dosyaAcilisTarihi.time.minute;
        let second = dosyaAcilisTarihi.time.second < 10 ? ("0" + dosyaAcilisTarihi.time.second) : dosyaAcilisTarihi.time.second;
        let tarih = day + "." + month + "." + dosyaAcilisTarihi.date.year + " " +
            hour + ":" + minute + ":" + second;
        return tarih;
    }

    hexToBase64(hex: string): string {
        const binary = hex.match(/.{1,2}/g)!.map(byte => parseInt(byte, 16));
        const bytes = new Uint8Array(binary);
        // @ts-ignore
        const base64 = btoa(String.fromCharCode.apply(null, bytes));
        return base64;
    }

    private sanitizeDosyaAdi(segment: string): string {
        return segment.replace(/[/\\:*?"<>|]/g, '_').replace(/\s+/g, ' ').trim();
    }

    private buildTakipTalebiAdi(
        birimAdi: string | undefined,
        esasNo: string | undefined,
        usedNames: Map<string, number>
    ): string {
        const birim = this.sanitizeDosyaAdi(birimAdi || '') || 'BilinmeyenBirim';
        const esas  = this.sanitizeDosyaAdi(esasNo  || '') || 'EsasYok';
        const base  = `Takip Talebi - ${birim} - ${esas}.udf`;
        const count = (usedNames.get(base) ?? 0) + 1;
        usedNames.set(base, count);
        if (count === 1) return base;
        const [name, ext] = [base.slice(0, base.lastIndexOf('.')), base.slice(base.lastIndexOf('.'))];
        return `${name}_${count}${ext}`;
    }

    async topluTakipTalebiIndir(uyapDosyalar: Array<{dosyaId: string; birimAdi?: string; esasNo?: string}>) {
        const zip = new JSZip();
        const usedNames = new Map<string, number>();
        for (const uyapDosya of uyapDosyalar) {
            try {
                const blobData: TakipTalebiIndirCevap = await app.$uyap.TakipTalebiIndir(uyapDosya.dosyaId).run({
                    download: true,
                    filename: "takip_talebi.udf"
                });
                const dosyaAdi = this.buildTakipTalebiAdi(uyapDosya.birimAdi, uyapDosya.esasNo, usedNames);
                zip.file(dosyaAdi, blobData.file);
            } catch {
                continue;
            }
        }
        const contents = await zip.generateAsync({type: "blob"});
        FileSaver.saveAs(contents, "Takip Talepleri");
    }

    trToEn(text: string): string {
        return text.toLowerCase()
            .replace(/Ç/g, 'c')
            .replace(/ç/g, 'c')
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/Ü/g, 'u')
            .replace(/ü/g, 'u')
            .replace(/Ğ/g, 'g')
            .replace(/ğ/g, 'g')
            .replace(/Ş/g, 's')
            .replace(/ş/g, 's')
            .replace(/İ/g, 'i')
            .replace(/ı/g, 'i')
    }

    seoUrl(text: string): string {
        text = text.replace(/\ /g, '-')
            .replace(/\(/g, '-')
            .replace(/\)/g, '-')
            .replace(/\//g, '-')
            .replace(/\\/g, '-');
        return this.trToEn(text);
    }

    turkishToUpper(str: string) {
        let letters: any = {
            "a": "A",
            "b": "B",
            "c": "C",
            "d": "D",
            "e": "E",
            "f": "F",
            "g": "G",
            "ğ": "Ğ",
            "h": "H",
            "ı": "I",
            "i": "İ",
            "j": "J",
            "k": "K",
            "l": "L",
            "m": "M",
            "n": "N",
            "o": "O",
            "ö": "Ö",
            "p": "P",
            "r": "R",
            "s": "S",
            "ş": "Ş",
            "t": "T",
            "u": "U",
            "ü": "Ü",
            "v": "V",
            "y": "Y",
            "z": "Z",
            "A": "A",
            "B": "B",
            "C": "C",
            "D": "D",
            "E": "E",
            "F": "F",
            "G": "G",
            "Ğ": "Ğ",
            "H": "H",
            "I": "I",
            "İ": "İ",
            "J": "J",
            "K": "K",
            "L": "L",
            "M": "M",
            "N": "N",
            "O": "O",
            "Ö": "Ö",
            "P": "P",
            "R": "R",
            "S": "S",
            "Ş": "Ş",
            "T": "T",
            "U": "U",
            "Ü": "Ü",
            "V": "V",
            "Y": "Y",
            "Z": "Z"
        }
        let out = "";
        for (let i = 0; i < str.length; i++) {
            if (typeof letters[str[i]] != "undefined")
                out += letters[str[i]];
            else
                out += str[i];
        }
        return out;
    }

    turkishToLower(str: string) {
        let letters: any = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
        // Regex TEK karakter eslestirmeli. Eskiden `/(([İIŞĞÜÇÖ]))+/g` idi: sondaki + yan yana
        // gelen Turkce buyuk harflerin TAMAMINI tek eslesme olarak yakaliyor, replacer'a gelen
        // deger "ÜÇÜ" gibi bir dizi oldugu icin letters[...] undefined donuyor ve metne literal
        // "undefined" yaziliyordu ("KÜÇÜKÇEKMECE" -> "kundefinedkçekmece").
        str = str.replace(/[İIŞĞÜÇÖ]/g, (letter: any) => {
            return letters[letter];
        })
        return str.toLowerCase();
    }

    /**
     * Icra dairesi adini karsilastirma icin normalize eder: bastaki/sondaki ve tekrar eden
     * bosluklari temizler, Turkce'ye duyarli kucuk harfe cevirir.
     * ("İstanbul Anadolu 1. İcra Dairesi " -> "istanbul anadolu 1. icra dairesi")
     */
    birimAdiNormalize(birimAdi: string | undefined | null): string {
        if (!birimAdi)
            return "";
        return this.turkishToLower(String(birimAdi).replace(/\s+/g, " ").trim());
    }

    /**
     * Karsilastirma icin KANONIK icra dairesi adi. UYAP yazimi ile IcraPro'nun kendi
     * icra_daireleri kayitlari (ve kullanicinin Excel'e yazdigi metin) arasinda degisen
     * parcalar atilir:
     *   - sondaki parantezli aciklama : "Ankara 1. Icra Dairesi ( Kapatilan )"
     *   - sonek                       : "Icra Dairesi" / "Icra Mudurlugu" / "Icra"
     *   - UYAP'in ekledigi niteleme   : "Genel"
     *   - sira numarasi noktasi       : "5." ile "5" ayni sayilir
     *   - yaygin kisaltmalar          : "MTS" -> "Merkezi Takip Sistemi"
     *
     * icra_daireleri tablosunda UYAP birim kimligi tutulmadigi icin bu akislar zorunlu
     * olarak ada bagimli; kanonik form o boslugu kapatiyor. Bu fonksiyon TEK KAYNAK olmali:
     * DosyaBul (gorev calisirken) ve GenelIslemFormWizard (Excel yuklenirken) ayni kurallari
     * uygulamak zorunda, aksi halde Excel'de kabul edilen bir satir gorev calisirken
     * eslesmez hale gelir.
     *
     * docs/DEV-2643 HAR kaydindaki GERCEK 355 UYAP daire adi uzerinde dogrulandi: 355 ayri
     * kanonik form, hicbir cakisma yok. "Iflas Dairesi" soneki bilerek KORUNUYOR, aksi halde
     * "Istanbul 1. Icra Dairesi" ile "Istanbul 1. Iflas Dairesi" birbirine karisirdi.
     */
    birimAdiKanonik(birimAdi: string | undefined | null): string {
        let kanonik = this.birimAdiNormalize(birimAdi);
        if (kanonik === "")
            return "";
        // GUVENLIK: kapatilmis / birlestirilmis yerel kayitlar CANLI bir daireye cozulmemeli.
        // Ornek: "Ankara 5. Icra Dairesi (Kapatilan)" ile "Ankara 5. Genel Icra Dairesi" ayni
        // ofis DEGIL; parantez ve "genel" atildiginda ikisi de "ankara 5" kanonigine duserdi ve
        // kapali daire icin acilan gorev YANLIS dosyada islem yapardi. Bos donuluyor: eslesme
        // olmuyor, kullanici satiri duzeltmeye yonlendiriliyor.
        if (/kapatıl|birleştiril/.test(kanonik))
            return "";
        // Talimat dosyalari ayni dairenin kaydi; ek gercek gorev kayitlarinda goruldu.
        kanonik = kanonik.replace(/\s*[-–]\s*talimat dosyası\s*$/, "");
        // Parantezli niteleme SONDA olmak zorunda degil: UYAP il ayirt edicisini adin ORTASINA
        // koyuyor ("Didim(Yenihisar) Icra Dairesi", "Eregli(Konya) Icra Dairesi" gibi 6 daire).
        kanonik = kanonik.replace(/\s*\([^)]*\)/g, " ");
        kanonik = kanonik.replace(/\s+/g, " ").trim();
        kanonik = kanonik.replace(/\s*(icra dairesi|icra müdürlüğü|icra md\.?|icra)$/, "");
        kanonik = kanonik.replace(/\bgenel\b/g, "");
        kanonik = kanonik.replace(/(\d+)\s*\./g, "$1");
        kanonik = kanonik.replace(/\s+/g, " ").trim();
        return this.birimAdiTakmaAdiCoz(kanonik);
    }

    /**
     * Kullanicilarin siklikla yazdigi kisaltmalari tam birim adina cevirir. Yalnizca kanonik
     * adin TAMAMI kisaltmaya esitse uygulanir; bir daire adinin ICINDE gecen harf dizisi
     * yanlislikla degistirilmesin. UYAP'in 355 daire adinda "mts" gecen kayit yok, dolayisiyla
     * bu takma ad hicbir gercek daire adiyla catismiyor.
     */
    birimAdiTakmaAdiCoz(kanonikAd: string): string {
        // MTS / M.T.S. / M T S -> Merkezi Takip Sistemi (UYAP birimId 1054286)
        if (/^m\.?\s*t\.?\s*s\.?$/.test(kanonikAd))
            return "merkezi takip sistemi";
        return kanonikAd;
    }

    /**
     * Esas no icerisindeki tum "YIL/SIRA" ciftlerini sayisal olarak dondurur.
     * Birlesen dosyalarda ("2016/7232 - ( 2015/7070 )") iki cift birden doner.
     *
     * Bu fonksiyon TEK KAYNAK olmali: DosyaBul (gorev calisirken) ve Genel Islem Sihirbazi'nin
     * tablo filtresi (kullanici listeyi daraltirken) ayni esas no'yu ayni sekilde ayristirmak
     * zorunda. Ayrisirlarsa kullanicinin ekranda gordugu satir gorev calisirken bulunamaz.
     * Ham split('/') KULLANILMAMALI: birlesen dosyada ikinci parca "7232 - ( 2015" olur ve
     * Number(...) NaN doner. (DEV-2722)
     */
    esasNoParcalari(esasNo: string | undefined | null): Array<{ yil: number, sira: number }> {
        if (!esasNo)
            return [];
        const parcalar: Array<{ yil: number, sira: number }> = [];
        const re = /(\d{4})\s*\/\s*(\d+)/g;
        let eslesme;
        while ((eslesme = re.exec(String(esasNo))) !== null) {
            parcalar.push({yil: parseInt(eslesme[1], 10), sira: parseInt(eslesme[2], 10)});
        }
        return parcalar;
    }

    /** Kurallar ve gerekceleri icin bkz. esasNoParcalari. */
    esasNoVaryantlari(esasNo: string | undefined | null): Array<string> {
        return this.esasNoParcalari(esasNo).map(p => p.yil + "/" + p.sira);
    }

    getDateNow(seperator: string, dateDiff: any, donemYil = false, useGMTPlus3 = false) {
        let today: Date | string = new Date();
        // Türkiye GMT+3 saat dilimi için düzeltme (sadece istendiğinde)
        if (useGMTPlus3) {
            today.setHours(today.getHours() + 3);
        }
        let dd: string | number = today.getDate();
        let mm: string | number = today.getMonth(); //January is 0!
        let yyyy = today.getFullYear();
        if (dateDiff) {
            if (dateDiff.indexOf("month") >= 0) {
                if (dateDiff.indexOf("-") >= 0) {
                    today.setMonth(mm - dateDiff.split('-')[1].trim());
                } else {
                    today.setMonth(mm + parseInt(dateDiff.split('+')[1].trim()));
                }
            }
            if (dateDiff.indexOf("day") >= 0) {
                if (dateDiff.indexOf("-") >= 0) {
                    today.setDate(dd - dateDiff.split('-')[1].trim());
                } else {
                    today.setDate(dd + parseInt(dateDiff.split('+')[1].trim()));
                }
            }
            if (dateDiff.indexOf("year") >= 0) {
                if (dateDiff.indexOf("-") >= 0) {
                    today.setFullYear(yyyy - dateDiff.split('-')[1].trim());
                } else {
                    today.setFullYear(yyyy + parseInt(dateDiff.split('+')[1].trim()));
                }
            }
        }
        dd = today.getDate();
        mm = today.getMonth() + 1;
        yyyy = today.getFullYear();

        if (!seperator)
            seperator = '/';
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        today = dd + seperator + mm + seperator + yyyy;
        if (donemYil == true) {
            today = yyyy + seperator + mm;
        }
        return today;
    }

    hash(obj: any) {
        let newObj: any = Object.assign({}, obj);
        if (newObj.hasOwnProperty("dosyaId")) {
            if (newObj.hasOwnProperty("kisiKurumId")) {
                // Borclu sorgusu: cevap dosyadan bagimsiz, dosyaId volatil — anahtara girmez.
                delete newObj.dosyaId;
            } else {
                // Dosya sorgusu: tek ayirt edici kimlik bu; ilk 21 karakter gozlemde sabit
                // (bilinen sinirlilik, dosya sorgulari ucretsiz oldugu icin kabul edilebilir).
                // dosyaId bazi taleplerde (orn. DosyaBorcluEgm) string|number olabildigi icin
                // substr'e vermeden once String(...) ile ceviriyoruz — sayi gelirse patlamasin.
                newObj.dosyaId = String(newObj.dosyaId).substr(0, 21);
            }
        }
        return Crypto.createHash('sha1').update(JSON.stringify(newObj)).digest().toString('hex');
    }

    async getBlobFromLink(URL: string): Promise<Blob> {
        return new Promise((resolve, reject) => {
            if(app.$store.getters.isEicraproDevMode){
                return resolve(new Blob())
            }
            app.$http({
                url: URL,
                method: 'GET',
                responseType: 'blob'
            }).then((response: any) => {
                console.log("response Blob",response);
                return resolve(response);
            }).catch((error) => {
                app.$toast.error(error.message)
                return reject(error);
            });
        })
    }

    changeUyapDateFormat(date: string): string {
        let tarih = new Date(date);
        let tarihObj = {
            gun: tarih.getDate(),
            ay: (tarih.getMonth() + 1),
            yil: tarih.getFullYear()
        }
        return `${tarihObj.gun}.${tarihObj.ay}.${tarihObj.yil}`;
    }

    tcKimlikNoValidate(tcKimlikNo: string): boolean {
        if(tcKimlikNo == "" || tcKimlikNo == null)
            return false;
        let value10 = Number(tcKimlikNo.toString().substring(10, 11));
        let value9 = Number(tcKimlikNo.toString().substring(9, 10));
        let odd = Number(tcKimlikNo.toString().substring(0, 1)) + Number(tcKimlikNo.toString().substring(2, 3)) +
            Number(tcKimlikNo.toString().substring(4, 5)) + Number(tcKimlikNo.toString().substring(6, 7)) +
            Number(tcKimlikNo.toString().substring(8, 9));
        let even = Number(tcKimlikNo.toString().substring(1, 2)) + Number(tcKimlikNo.toString().substring(3, 4)) +
            Number(tcKimlikNo.toString().substring(5, 6)) + Number(tcKimlikNo.toString().substring(7, 8));
        let digit10 = (odd * 7 - even) % 10;
        if (digit10 < 0) digit10 += 10;
        let total = (odd + even + value9) % 10;

        return !(digit10 != value9 || total != value10)
    }

    onlyDigit(text: string) {
        return text.replace(/[^0-9]/g, "");
    }

    setCookie(name: string, value: any, days: number) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    async takipSorgulaWordDownload(task: ITask) {
        let zip = new JSZip();
        for (const cTask of (task.childTasks as Array<ITask>)) {
            let path = (cTask.birim_adi + " - " + cTask.dosya_esas_no).replace('/', '_');
            let sorgulananAlanlar = cTask.data.sorguAlanlari.map((item: any) => item.name);
            let hataliAlanlar = cTask.response.data.hataliSorguAlanlari.map((item: any) => item.name);
            let header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
                "xmlns:w='urn:schemas-microsoft-com:office:word' " +
                "xmlns='http://www.w3.org/TR/REC-html40'>" +
                "<head><meta charset='utf-8'><title>Save File</title></head><body>";
            let footer = "</body></html>";
            // dosya alanaları
            if (hataliAlanlar.indexOf('dosyahesap') == -1 && sorgulananAlanlar.indexOf('dosyahesap') > 0) {
                let sourceHTML = header + cTask.response.data.dosya.dosyaHesapBilgileri.html + footer;
                const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                zip.file(path + "/Dosya Hesap Bilgileri.doc", file);
            }
            if (hataliAlanlar.indexOf('tahred') == -1 && sorgulananAlanlar.indexOf('tahred') > 0) {
                let sourceHTML = header + cTask.response.data.dosya.tahsilatReddiyat.html + footer;
                const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                zip.file(path + "/Tahsilat Reddiyat.doc", file);
            }
            // borçlu alanları
            for (let borclu of cTask.response.data.borclular.items) {
                let borcluPath = "/" + (borclu.kurumAdi ? borclu.kurumAdi : (borclu.adi + " " + borclu.soyadi));
                if (hataliAlanlar.indexOf('postaceki') == -1 && sorgulananAlanlar.indexOf('postaceki') > 0) {
                    let sourceHTML = header + borclu.postaCeki.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/Posta Çeki.doc", file);
                }
                if (hataliAlanlar.indexOf('bankahesap') == -1 && sorgulananAlanlar.indexOf('bankahesap') > 0) {
                    let sourceHTML = header + borclu.bankaBilgileri.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/Banka Hesap Bilgileri.doc", file);
                }
                if (hataliAlanlar.indexOf('takbis') == -1 && sorgulananAlanlar.indexOf('takbis') > 0) {
                    let sourceHTML = header + borclu.takbis.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/Takbis.doc", file);
                }
                if (hataliAlanlar.indexOf('dib') == -1 && sorgulananAlanlar.indexOf('dib') > 0) {
                    let sourceHTML = header + borclu.dib.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/Dış İşleri Bilgileri.doc", file);
                }
                if (hataliAlanlar.indexOf('gib') == -1 && sorgulananAlanlar.indexOf('gib') > 0) {
                    let sourceHTML = header + borclu.gib.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/GİB.doc", file);
                }
                if (hataliAlanlar.indexOf('gsm') == -1 && sorgulananAlanlar.indexOf('gsm') > 0) {
                    let sourceHTML = header + borclu.gsm.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/GSM.doc", file);
                }
                if (hataliAlanlar.indexOf('iski') == -1 && sorgulananAlanlar.indexOf('iski') > 0) {
                    let sourceHTML = header + borclu.iski.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/İSKİ.doc", file);
                }
                if (hataliAlanlar.indexOf('mernis') == -1 && sorgulananAlanlar.indexOf('mernis') > 0) {
                    let sourceHTML = header + borclu.mersis.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/Mernis.doc", file);
                }
                if (hataliAlanlar.indexOf('sgkhaciz') == -1 && sorgulananAlanlar.indexOf('sgkhaciz') > 0) {
                    let sourceHTML = header + borclu.sgkhaciz.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/SGK Haciz.doc", file);
                }
                if (hataliAlanlar.indexOf('icradosyakaydi') == -1 && sorgulananAlanlar.indexOf('icradosyakaydi') > 0) {
                    let sourceHTML = header + borclu.icraDosyaKaydi.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/İcra Dosya Kaydı.doc", file);
                }
                if (hataliAlanlar.indexOf('egm') == -1 && sorgulananAlanlar.indexOf('egm') > 0) {
                    let sourceHTML = header + borclu.egm.html + footer;
                    const file = new Blob([sourceHTML], {type: 'application/vnd.ms-word;charset=utf-8'});
                    zip.file(path + borcluPath + "/EGM.doc", file);
                }
            }
        }
        let contents = await zip.generateAsync({type: "blob"})
        FileSaver.saveAs(contents, 'Word Sorgu Sonuçları ' + new Date(task.updated_at).toISOString().substr(0, 10));
    }
}

export default function HelperPlugin(Vue: typeof _Vue): void {
    Vue.prototype.$uyapHelper = new UyapHelper();
}